<template lang="pug">
  b-navbar.header(:toggleable="toggleableValue", :type="networkType.indexOf('e') === 0 ? 'light' : 'dark'" :class="{ 'external' : networkType.indexOf('e') === 0 }")
    button.sidebar-open-button(
      type="button",
      @click="toggleSidebar")
      icon(name="folder", scale="2")
    b-navbar-brand.logo.text-center.p-0
      a.logo-link(
        :href="computedLink",
        target="_blank",
        rel="noopener noreferrer"
      )
        l-image(:src="`${AppState.Path.upload}/${user.profile}.png?cache=${timestamp}`", :placeholder="`${AppState.Path.image}/${networkType.indexOf('e') === 0 ? 'main_logo_b.png' : 'main_logo.png' }`", contain)
    b-navbar-toggle(target="nav_collapse")
    b-collapse#nav_collapse.collapse-wrap(is-nav)
      b-navbar-nav.nav
        b-nav-item(v-if="menuAuth.includes('device')" :to="{name: 'device-root'}")
          img(src="../../../assets/agent-icon.svg")
          span.text(v-if="networkType.indexOf('i') === 0") {{$t('remote_device')}} {{$t('manage')}}
          span.text(v-else v-t="'all-devices'")

        b-nav-item(v-if="menuAuth.includes('mdm')" :to="{name: 'mdm'}")
          icon(name="shield-alt")
          span.text {{$t('mdm_page.device_policy')}}

        b-nav-item(v-if="menuAuth.includes('group')" :to="{name:'groups'}")
          img(src="../../../assets/group-icon.svg")
          span.text {{$t('shared_group')}}
        
        b-nav-item(v-if="menuAuth.includes('department')" :to="{name:'department'}")
          img(src="../../../assets/unit_click.svg" width="15" height="15")
          span.text {{$t('department')}}

        b-nav-item(v-if="menuAuth.includes('user')" :to="{name: 'user'}")
          img(src="../../../assets/user-icon.svg")
          span.text {{$t('account-manage')}}

        b-nav-item(v-if="menuAuth.includes('management')" :to="{name: 'management'}")
          icon(name="cog")
          span.text(v-t="'manage'")
        
        b-nav-item(v-if="menuAuth.includes('statistics')" :to="{name: 'statistics'}")
          img(src="../../../assets/statistics-icon.svg")
          span.text {{$t('dashboard')}}

        b-nav-item(v-if="menuAuth.includes('support') && !AppState.isMobile" :to="{name: 'support'}")
          icon(name="microphone")
          span.text {{$t('download')}}

        b-nav-item(v-if="AppState.perm.isAdmin && !AppState.isMobile", :to="{name:'payment'}")
          img(src="../../../assets/pay-icon.svg")
          span.text {{$t('payment_manage')}}

      b-navbar-nav.right-nav.ml-auto.d-flex.align-items-center
        // @@@ 토글부분
        b-nav-item(v-if="menuAuth.includes('toggle')" style="display: flex; align-items: center;" @click="toggleViewMode")
          span.mr-2(:class="isSimpleMode ? 'view-mode-simple' : 'view-mode-normal'") {{viewModeName}}
          switches.lmm-switch(
            v-model="isSimpleMode",
            theme="bootstrap",
            :color="isSimpleMode ? 'success' : 'default'"
          )
        b-nav-item(style="display: flex; align-items: center;" @click="toggleConnectMode")
          span.mr-2(:class="connectMode ? 'view-mode-simple' : 'view-mode-normal'") {{connectModeName}}
          switches.lmm-switch(
            v-model="connectMode",
            theme="bootstrap",
            :color="connectMode ? 'success' : 'default'"
          )
        div(v-if="AppState.perm.isAdmin")
          span.adminId.nowrap(v-t="'manager-id'" @click="$router.push({name: 'profile'}).catch(()=>{})")
        div(v-else-if="AppState.perm.isSubManager")
          span.adminId.nowrap(v-t="'sub-manager-id'" @click="$router.push({name: 'profile'}).catch(()=>{})")
        div(v-else)
          span.adminId.nowrap(@click="$router.push({name: 'profile'}).catch(()=>{})") {{$t('user')}}
        b-nav-item.header-menu-icon(:to="{name: 'notice'}")
          img(src="../../../assets/announcement-icon.svg")
        b-nav-item.d-lg-flex.language(@click.stop="setDropdown('language')")
          icon(name="globe")
          span.text {{lang.current.text}}
          icon(name="caret-down")
          transition(name="dropdown")
            div.header-dropdown.select-language(:class="{ 'external': isExternal }" v-if="dropdownState === 'language'" ref="dropdown")
              ul
                li(v-for="la in lang.options", :key="la.value", @click="selectLang(la)") {{la.text}}
        
        b-nav-item.logout(@click="logout")
          span.text.nowrap(v-t="'logout'")
          icon(name="sign-out-alt")
</template>

<script>
import Switches from 'vue-switches'
import _ from 'lodash'
import {store} from '@/api/store'
import {getNetworkType, logout, user} from '@/api/access'
import {DeviceListAPI} from '@/api'
import {setPermission} from '../../../api/access'
import {getCurrentLanguage} from '@/i18n'
import {EventBus} from '../../management/EventBus'
import {CreateInstance} from '@/api/config'

const checkDelay = {
  active: 12000,
  deactive: 1200000,
}

const envcheckAPI = CreateInstance("temp_envcheck")

export default {
  name: "manager-header",
  components: { Switches },
  computed: {
    isSimpleMode: {
      get() {
        return this.viewMode === "simple"
      },
      set(value) {
        this.viewMode = value ? "simple" : "normal"
      }
    },
    networkType() {
      return store.get("networkType")
    },
    accountType() {
      return store.get('auth').account_type
    },
    computedLink() {
      const baseUrl = "https://www.linkmemine.com"
      const lang = this.$i18n.locale
      return `${baseUrl}/?lang=${lang}`
    },
    menuAuth() {
      const userInfo = this.user
      const isExternal = this.networkType.indexOf("e") === 0 // 내부/외부망 여부
      const isCorporate = this.accountType === 1 // 기업향 여부
      const isBasicPlan = userInfo.license.total.primaryProdType === 'Basic' // Basic 요금제 여부
      const role = userInfo.type // 사용자 권한
      const menus = {
        corporate: {
          internal: {
            Member: ["device", "group"],
            SubManager: ["device", "group", "user", "management", "support"],
            Manager: ["device", "mdm", "group", "department", "user", "management", "statistics", "support", "payment"],
          },
          external: {
            Member: ["device", "user", "management", "support", "toggle"],
            SubManager: ["device", "user", "management", "support", "toggle"],
            Manager: ["device", "user", "management", "support", "payment", "toggle"],
          },
        },
        personal: {
          internal: {
            Member: ["device", "group"],
            SubManager: ["device", "group", "user", "support"],
            Manager: ["device", "mdm", "group", "user", "management", "statistics", "support", "payment"],
          },
          external: {
            Member: ["device", "user", "management", "support", "toggle"],
            SubManager: ["device", "user", "management", "support", "toggle"],
            Manager: ["device", "user", "management", "support", "payment", "toggle"],
          },
        },
      }
      
      const groupType = isCorporate ? "corporate" : "personal"
      const networkType = isExternal ? "external" : "internal"

      let result = menus[groupType][networkType][role] || []

      // 내부망에서 common_policy와 ip_policy가 둘 다 false면 management 탭 제거
      if (!isExternal && this.summary) {
        if (!this.summary.common_policy && !this.summary.ip_policy) {
          result = result.filter(menu => menu !== 'management')
        }
      }

      // 라이선스 게이트: MDM 요금제(isMdm) 아니면 mdm 메뉴 제거 (07-03 isMdm SSOT)
      if (!this.AppState.isMdm) {
        result = result.filter(menu => menu !== 'mdm')
      }

      return result
    },
    isExternal() {
      return this.networkType.indexOf("e") === 0
    },
    toggleableValue() {
      const type = this.accountType === 1 ? 'corporate' : 'personal'
      const network = this.networkType.indexOf("e") === 0 ? 'external' : 'internal'
      const key = `${network}_${type}_${this.currentLang}`
      
      const mapping = {
        external_personal_ko: 'gnb_external_personal_ko',
        external_personal_en: 'gnb_external_personal_en',
        external_personal_jp: 'gnb_external_personal_jp',
        external_corporate_ko: 'gnb_external_corporate_ko',
        external_corporate_en: 'gnb_external_corporate_en',
        external_corporate_jp: 'gnb_external_corporate_jp',
        
        internal_personal_ko: 'gnb_internal_personal_ko',
        internal_personal_en: 'gnb_internal_personal_en',
        internal_personal_jp: 'gnb_internal_personal_jp',
        internal_corporate_ko: 'gnb_internal_corporate_ko',
        internal_corporate_en: 'gnb_internal_corporate_en',
        internal_corporate_jp: 'gnb_internal_corporate_jp'
      }
      
      return mapping[key] || 'gnb_personal_ko'
    },
  },
  methods: {
    toggleSidebar() {
      this.AppState.Sidebar = !this.AppState.Sidebar
    },
    setDropdown(key) {
      if (this.dropdownState === key) this.dropdownState = null
      else this.dropdownState = key
    },
    selectLang(lang) {
      // loadLanguageAsync(lang.value)
      // this.lang.current = lang
      let { name, params, query } = this.$route
      params.lang = lang.value
      store.set("lang", params.lang)
      this.$router.push({ name, params, query })
    },
    getSummary(cb) {
      // if (process.env.NODE_ENV === "development" && this.devCheck !== null) return
      // if (!document.hasFocus()) return
      if (this.onProgress) return
      this.onProgress = true
      DeviceListAPI.get("summary").then(resp => {
        this.onProgress = false
        let newSum = resp.data.objects[0]
        let ticket = resp.data.meta
        if (!_.isEqual(this.summary, newSum)) {
          store.set("summary", newSum)
          this.AppState.$emit("summary-update", newSum)
          this.summary = newSum
          this.AppState.$emit("device-state-change")
          this.AppState.setSummary(newSum)
        }
        if (!_.isEqual(this.tickets, ticket)) {
          store.set("tickets", ticket)
          this.tickets = ticket
          this.AppState.setTicketSummary(ticket)
          this.AppState.$emit("ticket-state-change")
          if (cb) cb(ticket)
        }
        setPermission(this.user, true)
        this.devCheck = true
      })
    },
    getSummaryInterval() {
      if (this.checker.timer) {
        clearInterval(this.checker.timer)
      }
      this.getSummary()
      this.checker.timer = setInterval(() => {
        this.getSummary()
      }, this.checker.delay)
    },
    async logout() {
      await logout()
      // window.location.href = window.location.pathname || '/'
      const { lang } = this.$route.params
      this.$router.push({ name: "login", params: { lang } })
      // this.$router.push({ name: "error", params: { code: "logout" } })
    },
    toggleViewMode() {
      this.viewMode = this.viewMode === "simple" ? "normal" : "simple"
    },
    async toggleConnectMode() {
      if (this.isTogglingConnectMode) return

      this.isTogglingConnectMode = true
      let networkPassFlag = store.get("networkPassFlag")
      let isSuperadminLogin = store.get("isSuperadminLogin")

      try {
        // 기업향의 체크툴 검사가 필요한 경우 (슈퍼관리자 강제 로그인은 스킵)
        const needCheckTool = this.accountType === 1 &&
            this.networkType.indexOf('i') === 0 &&
            this.user.flag_function_manager_approval === 1 &&
            !networkPassFlag &&
            !isSuperadminLogin
        if (needCheckTool) {
          await this.runCheckTool()
        }
        this.updateConnectMode()
      } catch (error) {
        const userMessage = this.getErrorMessage(error.message)
        this.$awn.warning(userMessage)
      } finally {
        this.isTogglingConnectMode = false
      }
    },
    // 환경 체크 툴 실행 관련 함수
    async runCheckTool() {
      try {
        let { data: { objects } } = await envcheckAPI.post("", { login_id: this.user.mgrid })
        
        // 문서 타이틀 수정
        window.top.document.title = `LMM_SE_ENVCHK:${objects}:${this.user.mgrid}:`
        
        // 환경 체크 툴 다운로드
        let a = document.createElement("a")
        // a.href = "https://tss.linkmemine.com/download/LMM_SE_Launcher.exe"
        // a.download = "LMM_SE_Launcher.exe"
        a.href = "./download/LMM_SE_Launcher.exe\n"
        a.download = "LMM_SE_Launcher.exe\n"
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        
        // 환경 체크 상태 확인 (polling 방식)
        await this.getEnvironmentStatus(objects)
        
        return true
      } catch (error) {
        throw error
      }
    },
    // 연결 모드 및 네트워크 타입 업데이트
    async updateConnectMode() {
      window.top.document.title = 'LinkMeMine'
      this.connectMode = !this.connectMode

      let tempNetworkType = this.connectMode ? 'manager' : 'user'
      let changeNetworkType = getNetworkType(tempNetworkType)

      store.set("networkType", changeNetworkType)
      store.set("networkPassFlag", 1)

      // IndexedDB 저장 완료 대기 후 리로드
      await store.flush()

      // 모드 전환 시 원격기기 페이지로 이동 후 리로드
      const { lang } = this.$route.params
      window.location.href = `/#/${lang}/device`
      window.location.reload()
    },
    handleOutsideClick(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.dropdownState = null
      }
    },
    // 환경 체크 상태 확인 함수
    async getEnvironmentStatus(envPk, maxRetries = 6, baseDelay = 1000, maxDelay = 8000) {
      for (let attempt = 0; attempt < maxRetries; attempt++) {
        let checkToolResult = await envcheckAPI.get("config-value-return", {
          params: { input_type: "env_check_status", pk: envPk }
        })
        
        let status = checkToolResult.data.objects
        
        // 체크툴 성공했을 경우 분기
        if (status === "success") {
          let resp = await envcheckAPI.get("config-value-return", {
            params: {input_type: "registration_status", user_id: this.user.mgrid, pk: envPk,}
          })
          
          let {manager_device_pk, registration_status, manager_device_id = null} = resp.data.objects
          
          // 등록된 매니저 디바이스가 없는 경우
          if (!manager_device_pk && !registration_status) {
            throw new Error("Manager device not registered")
          }
          
          // 매니저 디바이스가 신청 중인 경우
          if (registration_status === 0 ) {
            throw new Error("Manager device pending approval")
          }
          
          return true
        } else if (status && status !== 'success') {
          // 체크툴 예외
          throw new Error(`Environment check failed`)
        }
        
        let delay = Math.min(baseDelay * Math.pow(2, attempt) * (0.5 + Math.random() * 0.5), maxDelay)
        // console.log(`환경 체크 재시도 (${attempt + 1}/${maxRetries}), ${delay.toFixed(0)}ms 후 재시도`)
        await new Promise(resolve => setTimeout(resolve, delay))
      }
      // 체크툴 다운로드 시간 초과
      throw new Error("Environment check timeout")
    },
    getErrorMessage(error) {
      if (error.includes(':')) {
        let temp = error.split(":")
        error = temp[1].replace(';','')
      }
      
      switch (error) {
        case 'Environment check failed':
          return this.$t("environmentCheckError.environmentCheckFailed");
        case 'Manager device pending approval':
          return this.$t("environmentCheckError.managerDevicePendingApproval");
        case 'Manager device not registered':
          return this.$t("environmentCheckError.managerDeviceNotRegistered");
        case 'Environment check timeout':
          return this.$t("environmentCheckError.environmentCheckTimeout");
        default:
          return null; // 알 수 없는 오류는 null 반환
      }
    },
  },
  created() {
    if (this.user === null) {
      this.logout()
      return
    }
    let stored = store.get("summary")
    // 내부망이면 무조건 normal 모드 (스토어 값 무시)
    if (this.networkType.indexOf('i') === 0) {
      this.viewMode = "normal"
    } else {
      this.viewMode = store.get("viewMode") || "normal"
    }
    this.viewModeName = this.viewMode === "simple" ? "SIMPLE" : "NORMAL"
    this.connectMode = this.networkType.indexOf("i") === 0
    this.connectModeName = this.networkType.indexOf('i') === 0 ? this.$t('internal') : this.$t('external')
    if (stored) {
      this.summary = stored
      this.AppState.setSummary(stored)
    }

    let storedTicket = store.get("tickets")
    if (storedTicket) {
      this.tickets = storedTicket
      this.AppState.setTicketSummary(stored)
    }

    this.getSummary(ticket => {
      if (!storedTicket && ticket.request_ticket) {
        this.$awn.info(this.$t("has_request_ticket", { count: ticket.request_ticket }))
      }
    })
    this.getSummaryInterval()
    this.AppState.$on("logo-changed", () => {
      this.timestamp = new Date().getTime()
    })

    window.onblur = () => {
      this.checker.delay = checkDelay.deactive
      this.getSummaryInterval()
    }

    window.onfocus = () => {
      this.checker.delay = checkDelay.active
      this.getSummaryInterval()
    }

    let lang = this.$route.params.lang
    this.lang.current = _.find(this.lang.options, { value: lang })

    this.AppState.$on("app-logout", () => {
      this.logout()
    })

    this.currentLang = lang

    //통계탭 분기처리
    let authVal = this.user.auth_val
    authVal = authVal.split(",")
    for (var i = 0; i < authVal.length; i++) {
      if (authVal[i] == 8) {
        this.statistics = true
      } else {
        this.statistics = false
      }
    }
    
    document.addEventListener('click', this.handleOutsideClick)
  },
  watch: {
    $route(r) {
      let lang = r.params.lang
      this.lang.current = _.find(this.lang.options, { value: lang })
    },
    viewMode(newValue) {
      // 내부망이 아닐 때만 스토어에 저장
      if (this.networkType.indexOf('i') !== 0) {
        store.set("viewMode", newValue)
      }
      this.viewModeName = newValue === "simple" ? "SIMPLE" : "NORMAL"
      EventBus.$emit("view-mode-changed", newValue)
      this.AppState.viewMode = newValue
    },
    connectMode(newValue) {
      this.connectModeName = newValue ? this.$t('internal') : this.$t('external')
    },
  },
  beforeDestroy() {
    window.onblur = null
    window.onfocus = null
    if (this.checker.timer) clearInterval(this.checker.timer)
    this.AppState.$off("logo-changed")
    document.removeEventListener('click', this.handleOutsideClick)
  },
  data() {
    const userData = user()
    let initDelay = document.hasFocus() ? checkDelay.active : checkDelay.deactive
    let currentLang = getCurrentLanguage()
    if (currentLang === "ko") currentLang = "kr"
    return {
      devCheck: null,
      onProgress: false,
      timestamp: 0,
      dropdownState: null,
      summary: null,
      tickets: null,
      isTogglingConnectMode: false,
      checker: {
        timer: null,
        delay: initDelay,
      },
      lang: {
        current: null,
        options: [
          { value: "ko", text: "KO" },
          { value: "en", text: "EN" },
          { value: 'jp', text: 'JP' }
        ],
      },
      osIcons: ["desktop", "brands/windows", "brands/linux", "brands/apple", "brands/android", "mobile"],
      user: userData,
      manual: `${this.AppState.Path.download}/manual/${currentLang}`,
      statistics: false,
      menuDevice: false,
      viewMode: "normal",
      viewModeName: "NORMAL",
      connectMode: false,
      connectModeName: "",
    }
  },
}
</script>
<style lang="scss" scoped>
$nav-background-color: #232f3e;
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  // height: 53px;
  padding: 0;
  background-color: $nav-background-color;
  z-index: 1072;
  // @media (max-width: 768px) {
  //   height: auto;
  // }
}

.external::v-deep {
  &.header {
    background-color: #fff;
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.5);
  }
  .collapse-wrap {
    background-color: #fff;
  }
  .navbar-nav .nav-link {
    color: #1d2735;
    img {
      filter: invert(100%) sepia(53%) saturate(471%) hue-rotate(174deg) brightness(91%) contrast(89%);
    }

    &:hover {
      // background-color: #555;
      color: #ec7211;
      // border-bottom: 4px solid #31b6ca;
      img {
        filter: invert(51%) sepia(52%) saturate(951%) hue-rotate(347deg) brightness(91%) contrast(104%);
        // invert(55%) sepia(47%) saturate(3800%) hue-rotate(355deg) brightness(96%) contrast(94%);
      }
    }
  }

  .view-mode-normal,
  .adminId {
    color: #1d2735;
  }

  .sidebar-open-button {
    color: #1d2735;
  }
}

.adminId {
  cursor: pointer;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30px;
  padding: 0;
  background-color: $nav-background-color;
  z-index: 1071;
  text-align: right;
  color: red;
}

.collapse-wrap {
  background-color: $nav-background-color;
}

.select-language-in-mobile {
  padding: 0 20px;
}

.sidebar-open-button {
  border: 0;
  background-color: transparent;
  color: white;
  outline: none;
  @media (min-width: 992px) {
    display: none;
  }
}

.alert-count {
  transform: translate(-5px, -10px);
}

.logo {
  // 임시 패딩값 나중엔 중앙정렬
  padding-top: 7px;
  margin: 1.5rem;
  width: 170px;
  height: 20px;
  float: left;

  .logo-link {
    display: flex;
    width: 170px;
    height: 20px;
    align-items: center;
    justify-content: center;
  }
}

.os {
  display: inline-block;
  width: 60px;
  .os-icon {
  }
  .os-text {
    display: inline-block;
    padding: 0 10px;
  }
}

.os-wrap {
  cursor: default;
  border-top: 1px solid #ebebeb;
  background-color: #f0f0f0;
}

.status {
  cursor: default;
  // .status-label {}
  .status-value {
    float: right;
  }
}

.header-dropdown {
  position: absolute;
  top: 52px;
  right: 0;
  ul {
    padding: 0;
    list-style: none;
    border: 1px solid #ebebeb;
    background-color: white;
    li {
      color: #888;
      padding: 0 20px;
    }
  }

  &.summary {
    ul {
      li {
        white-space: nowrap;
        min-width: 120px;
      }
    }
  }
}

.right-nav {
  > li {
    line-height: 50px;

    > a {
      display: block;
      padding: 0 15px !important;
      height: 53px;
      color: #fff;
      font-size: 13px;
      // line-height: 60px;

      > svg {
        vertical-align: middle;
      }
      > .text {
        display: inline-block;
        padding: 0 5px;
        vertical-align: top;
      }
    }
    &.alert-icon {
      position: relative;
    }
    &.logout {
      .fa-icon {
        display: none;
      }
    }
    &.language {
      position: relative;
    }
  }
}

.nav {
  > li {
    line-height: 50px;
    position: relative;
    > a {
      padding: 0 15px !important;
      height: 53px;
      color: #d6d6d6;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;

      > svg {
        vertical-align: middle;
      }
      > .text {
        display: inline-block;
        padding: 0 5px;
        vertical-align: top;
      }

      &:hover {
        // background-color: #555;
        color: #ec7211;
        // border-bottom: 4px solid #31b6ca;
        img {
          filter: invert(51%) sepia(52%) saturate(951%) hue-rotate(347deg) brightness(91%) contrast(104%);
          // invert(55%) sepia(47%) saturate(3800%) hue-rotate(355deg) brightness(96%) contrast(94%);
        }
      }

      &.nav-link.router-link-active {
        color: #ec7211;
        font-weight: 500;
        img {
          filter: invert(51%) sepia(52%) saturate(951%) hue-rotate(347deg) brightness(91%) contrast(104%);
        }
        // border-bottom: 4px solid #31b6ca;
      }
    }
  }
  //drop-menu 미완성
  .drop-menu {
    position: absolute;
    // transform: translate(-50%, -50%);
    // left: 50%;
    // top: 195%;
    top: 53px;
    left: 0;
    margin: 0;
    padding: 0;
    box-shadow: 0px 0px 7px 5px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    > li {
      list-style: none;
      background: #eee;
      width: 109px;
      text-align: center;
      border-radius: 2px;
      &:hover {
        color: #31b6ca;
      }
      &:hover a {
        color: #31b6ca;
      }
      > a {
        text-decoration: none;
        color: #232323;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.adminId {
  color: #fff;
  line-height: 50px;
  padding: 0 10px;
  font-size: 13px;
}

.download {
  color: #f1f1f1;
}

span.download {
  padding-left: 3px;
}

@media (max-width: 991px) {
  .mobile-language {
    border-top: 1px solid #5d5d5d;
  }
  .nav > li > a.nav-link {
    &.router-link-active {
      background-color: transparent;
      color: #31b6ca;
      font-weight: 500;
      border-bottom: 0px;
    }
    &:hover {
      background-color: transparent;
      color: #31b6ca;
      font-weight: 500;
      border-bottom: 0px;
    }
  }
}

.nav-link {
  display: flex !important;
  align-items: center;
}

.view-mode-simple {
  color: #ec7211;
  font-size: 13px;
  font-weight: 400;
}

.view-mode-normal {
  color: #d2d2d2;
  font-size: 13px;
  font-weight: 400;
}

.select-language {
  > ul {
    background-color: #394958;
    border: 1px solid #4a5a6a;
    border-radius: 8px;
    padding: 5px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);
    
    > li {
      color: #ffffff;
      cursor: pointer;
      transition: background-color 0.3s ease, color 0.3s ease;
      font-size: 14px;
    }
    
    > li:hover {
      background-color: #4a5a6a;
      color: #ec7211;
    }
    
    > li:not(:last-child) {
      border-bottom: 1px solid #556677;
    }
  }
  
  &.external > ul {
    background-color: #f2f4f7;
    border-color: #d1d6de;
    
    > li {
      color: #222;
    }
    
    > li:hover {
      background-color: #dce1e8;
      color: #ec7211;
    }
    
    > li:not(:last-child) {
      border-bottom: 1px solid #c5cbd5;
    }
  }
}

.header-menu-icon {
  &:hover,
  &.active {
    filter: invert(51%) sepia(52%) saturate(951%) hue-rotate(347deg) brightness(91%) contrast(104%);
  }
}

.new-badge {
  font-size: 0.8rem;
  margin-right: 0.4rem;
  margin-bottom: 0.7rem;
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  30% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

// @media (max-width: 1370px) {
//   .logout {
//     .text {
//       display: none !important;
//     }
//     .fa-icon {
//       display: block !important;
//     }
//   }
// }
@media (max-width: 1340px) {
  .new-badge {
    display: none;
  }
}
@media (max-width: 1305px) {
  .lmm-switch {
    display: block;
  }
}
// @media (max-width: 1270px) {
//   .nav > li > a {
//     &:not(.router-link-active) {
//       > .text {
//         display: none;
//       }
//     }
//   }
// }
// @media (max-width: 1070px) {
//   .nav > li > a {
//     > .text {
//       display: none;
//     }
//   }
// }
.nowrap {
  white-space: nowrap;
}

.dropdown-enter-active, .dropdown-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.dropdown-enter, .dropdown-leave-to { /* leave-to는 Vue 2에서 사용 */
  opacity: 0;
  transform: translateY(-10px);
}
</style>
